// extracted by mini-css-extract-plugin
export default {"successBox":"whyChooseUs_successBox__ixl9c"};